<div class="modal-content-container">

  <section class="header-container">
    <div class="animated fadeInUp img-mushroom d-none d-lg-block d-md-block d-sm-none"></div>
    <div class="animated fadeInDown img-peaches d-none d-lg-block d-md-block d-sm-none"></div>
    <header class="text-center d-flex flex-column gap-3">
      <h1 class="h1-bold">
        <p class="m-0">Hello Neighbor<span class="dot-is-blue">.</span></p>
      </h1>
    </header>

    <div class="text-center mt-3">
      <i class="fas fa-cart-shopping fa-2x text-primary"></i>
    </div>

    <article class="text-center px-5 mt-3">
      Great news—you're in our delivery zone! Time to stock up on fresh, local produce!
    </article>
  </section>

  <div class="d-grid gap-2 col-md-8 mx-auto mt-5">
    <div class="row">
      <div class="col-md-6">
        <button type="button" class="btn btn-secondary rounded-pill w-100 py-3" (click)="signUp()">Sign Up</button>
      </div>
      <div class="col-md-6">
        <button type="button" class="btn btn-primary rounded-pill w-100 py-3" (click)="returnToStore()">Go to the Market</button>
      </div>
    </div>
  </div>
</div>
